export default function getImageFromSource(imagePath: string): string {
	if (!imagePath) return "";

	if (imagePath[0] === "/") return require("@/assets" + imagePath);
	else if (imagePath[0] === "@") return require("@/assets" + imagePath.replace("@/assets", ""));
	else return imagePath;
}
